import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ContractFactory from "../../Entity/Factories/ContractFactory";

export default function* contractForContractDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `contracts/${action.payload?.contractId}`);

    const contract = ContractFactory.create(res.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, contract);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchContractForContractDetailsPage() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_FOR_CONTRACT_DETAILS_PAGE, contractForContractDetailsPage);
}
